











import { Vue, Component, Prop } from "vue-property-decorator";

import CustomContainer from "@/components/Globals/CustomContainer.vue";
import SwatchesGroup from '@/components/Globals/molecule.swatchGroup.vue';
import type { subGroupType } from "./Globals/types/custom.t";
import { ICustomStylingClass } from "./Globals/types/custom.t";

@Component({
  components: {
    CustomContainer,
    SwatchesGroup
  },
})

export default class Swatches extends Vue {

  @Prop()
  activeGroup!: string;

  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop()
  customStyle?: ICustomStylingClass[];

  @Prop()
  groupName!: string;

  @Prop()
  swatchesToRenderOrdered!: subGroupType[];

  hasTitleProperties(group: string) {
    return this.getTabData(group)?.title || this.getTabData(group)?.subtitle;
  }

  getTabData(group: string) {
    return this.$store.state.swatches.groupTabs[group];
  }

}
